import { render, staticRenderFns } from "./EventDetailsManagement.vue?vue&type=template&id=5c1d5450&"
import script from "./EventDetailsManagement.vue?vue&type=script&lang=js&"
export * from "./EventDetailsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports